import { Box, Stack, Typography } from "@mui/material";
import { DatalayerSycCard, Ecwid, SyncCard } from "features/dataConnectors";
import { ApiProject, ApiService, ApiSyncType } from "@incendium/api";
import Ecwid_logo from "Assets/Images/ThirdParty/Ecwid_LSLockup_BlackRGB_Ecwid_EN.svg";
import ProjectCodeSnippet from "features/project/components/ProjectCodeSnippet";
import AccordianGlassCard from "Components/UI/AccordianGlassCard";
import { OAUTH_REDIRECT_URL } from "features/auth/constants";
import { useState } from "react";

interface IOnboardingEcwidProps {
  project: ApiProject;
}

function OnboardingEcwid({ project }: IOnboardingEcwidProps) {
  const [appOpen, setAppOpen] = useState(true);
  const [manualOpen, setManualOpen] = useState(false);

  return (
    <Stack spacing={4}>
      <AccordianGlassCard
        onOpenChange={(b) => setAppOpen(b)}
        defaultClosed={!appOpen}
        title={
          <>
            <Typography variant="subtitle1">
              Install Incendium App (recomended)
            </Typography>
            <Typography variant="body1">
              The best and easiest way to install the Incendium pixel is to
              connect via our ecwid app
            </Typography>
          </>
        }
      >
        <Typography variant="body1" mb={2}>
          To do that you can click the connect button below, then once connected
          select your store from the dropdown.
        </Typography>

        <SyncCard
          logo={Ecwid_logo}
          type={ApiSyncType.ECWID_API}
          title="Ecwid"
          description="Connect with your ECWID store for more accurate tracking and ecommerce insights."
          service={ApiService.ECWID}
          configComponent={Ecwid}
          state={OAUTH_REDIRECT_URL}
          imageSx={{ maxHeight: 32 }}
        />
      </AccordianGlassCard>

      <AccordianGlassCard
        onOpenChange={(b) => setManualOpen(b)}
        defaultClosed={!manualOpen}
        title={
          <>
            <Typography variant="subtitle1">
              Manually Install Incendium
            </Typography>
            <Typography variant="body1">
              You can add the Incendium Pixel to your store by embedding it in
              your theme or using Google Tag Manager (GTM).
            </Typography>
          </>
        }
      >
        <ProjectCodeSnippet project={project} />
        <Typography variant="body1" mt={2}>
          However, since Ecwid operates in a closed environment and functions as
          a Single Page Application (SPA), this method may not provide fully
          accurate tracking.
        </Typography>
        <Typography variant="body1">
          For better tracking enable Pageview Tracking via Data Layer in GTM to
          improve accuracy.
        </Typography>
        <Box sx={{ width: 450 }} my={2}>
          <DatalayerSycCard />
        </Box>
      </AccordianGlassCard>
    </Stack>
  );
}

export default OnboardingEcwid;
